
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import * as Yup from "yup";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import moment from "moment";
import { useToast } from "vue-toastification";

interface FacultyDetails {
  degree: string;
  email: string;
  fullname: string;
  research_description: string;
  address: string;
}

export default defineComponent({
  name: "edit-faculty",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD, YYYY");
    },
  },
  components: {

  },
  props: {
    facultyDetail: Object,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const facultyDetails = ref(props.facultyDetail);
    console.log(facultyDetails);
    const submitButton1 = ref<HTMLElement | null>(null);
    const toast = useToast();

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const IsStudent = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("student") !== -1) {
        return "Yes";
      }
      return "No";
    });


    const saveChanges1 = (send : boolean) => {
      if (submitButton1.value) {
        console.log(facultyDetails.value);
        // Activate indicator
        submitButton1.value.setAttribute("data-kt-indicator", "on");

        const jsonRequest = {
          irbApplicationId: route.params.id,
          sponsorDegree: facultyDetails?.value?.degree,
          email: facultyDetails?.value?.email,
          fullname: facultyDetails?.value?.fullname,
          reseachDescription: facultyDetails?.value?.research_description,
          address: facultyDetails?.value?.address,
        };

        var json = JSON.stringify(jsonRequest);
        var dispatchAction = Actions.POST_IRB_FACULTY;
        if (send) {
          dispatchAction = Actions.POST_IRB_FACULTY_SEND;
        }
        store
          .dispatch(dispatchAction, json)
          .then(() => {
            console.log("wp");
            submitButton1.value?.removeAttribute("data-kt-indicator");
            toast.success(currentFaculty.value.message, {
                timeout: 2000
              });
              if (send) {
                router.push({
                  name: "view-overview",
                  params: { id: route.params.id },
                });
              } else {
                router.push({
                  name: "allreview",
                  params: { id: route.params.id },
                });
              }

          })
          .catch(() => {
            submitButton1.value?.removeAttribute("data-kt-indicator");
            toast.error(store.getters.getIrbError, {
                timeout: 2000
              });
          });
      }
    };

    const currentFaculty = computed(() => {
      return store.getters.currentFaculty;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication != null?store.getters.currentApplication.data:{};
    });


    onMounted(async () => {
      console.log("mounted: " + route.params.id);
      await store.dispatch(
        Actions.GET_IRB_APPLICATION_FACULTY,
        route.params.id
      );

      setCurrentPageBreadcrumbs("Faculty", ["Application"]);
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(
          Actions.GET_IRB_APPLICATION_FACULTY,
          route.params.id
        );
      }
    );

    return {
      facultyDetails,
      currentFaculty,
      submitButton1,
      saveChanges1,
      currentApplication,
      IsStudent,
    };
  },
});
